import { render, staticRenderFns } from "./ProductRequestsModal.vue?vue&type=template&id=4ae33f38&scoped=true&"
import script from "./ProductRequestsModal.vue?vue&type=script&lang=js&"
export * from "./ProductRequestsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae33f38",
  null
  
)

export default component.exports